module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The Monkey Wrench Gang"), _c('br'), _vm._v("Copyright © 1975, 1985 by Edward Abbey, renewed 2003 by Clarke Abbey"), _c('br'), _vm._v("Cover art to the electronic edition copyright © 2011 by RosettaBooks, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Electronic edition published 2011 by RosettaBooks LLC, New York."), _c('br'), _vm._v("ISBN e-Pub edition: 9780795317361")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e47ea12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_cop_r1.vue
// module id = 63
// module chunks = 0